import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CompareExportsModule } from 'src/app/extensions/compare/exports/compare-exports.module';
import { OrderTemplatesExportsModule } from 'src/app/extensions/order-templates/exports/order-templates-exports.module';
import { QuotingExportsModule } from 'src/app/extensions/quoting/exports/quoting-exports.module';
import { RatingExportsModule } from 'src/app/extensions/rating/exports/rating-exports.module';
import { WishlistsExportsModule } from 'src/app/extensions/wishlists/exports/wishlists-exports.module';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { AppFacade } from 'ish-core/facades/app.facade';
import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';
import { ProductIdComponent } from 'ish-shared/components/product/product-id/product-id.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductInventoryComponent } from 'ish-shared/components/product/product-inventory/product-inventory.component';
import { ProductItemVariationsComponent } from 'ish-shared/components/product/product-item-variations/product-item-variations.component';
import { ProductLabelComponent } from 'ish-shared/components/product/product-label/product-label.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { ProductPriceComponent } from 'ish-shared/components/product/product-price/product-price.component';
import { ProductQuantityComponent } from 'ish-shared/components/product/product-quantity/product-quantity.component';
import { ProductShipmentComponent } from 'ish-shared/components/product/product-shipment/product-shipment.component';
import { ProductMarketingLabelComponent } from 'ish-shared/dias/components/product/product-marketing-label/product-marketing-label.component';

@Component({
  selector: 'ish-product-row',
  templateUrl: './product-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ProductImageComponent,
    ProductLabelComponent,
    ProductNameComponent,
    RatingExportsModule,
    ProductIdComponent,
    // ProductPromotionComponent,
    QuotingExportsModule,
    CompareExportsModule,
    OrderTemplatesExportsModule,
    WishlistsExportsModule,
    ServerHtmlDirective,
    ProductPriceComponent,
    ProductInventoryComponent,
    ProductShipmentComponent,
    ProductItemVariationsComponent,
    ProductQuantityComponent,
    ProductAddToBasketComponent,
    // ProductChooseVariationComponent,
    TranslateModule,
    ProductMarketingLabelComponent,
  ],
})
export class ProductRowComponent implements OnInit {
  private context = inject(ProductContextFacade);
  private appFacade = inject(AppFacade);

  product$: Observable<ProductView>;
  quantity$: Observable<number>;

  ngOnInit() {
    this.product$ = this.context.select('product');
    this.quantity$ = this.context.select('quantity');
  }

  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }

  openQuickView(productSku: string) {
    this.appFacade.openQuickView(productSku);
  }
}
